import { useMemo } from 'react';

import moment from 'moment';

const fixedDay = 5;

export const useBillingDate = () => {
    const estimatedBillingMs = useMemo(() => {
        const today = moment().date();
        if (today < fixedDay) {
            return moment(moment().format('YYYY-MM-05')).valueOf();
        }
        return moment(moment().add(1, 'M').format('YYYY-MM-05')).valueOf();
    }, []);

    const estimatedBillingDate = moment(estimatedBillingMs).format('YYYY.MM.DD');

    return {
        estimatedBillingMs,
        estimatedBillingDate,
    };
};
